<style scoped>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
  .ipt-sty {
    width: 70% !important;
  }
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">终端名称</div>
          <el-input size="mini" v-model="page.customerName" class="ipt-sty" placeholder="请输入终端名称"></el-input
        ></el-col>
        <el-col :span="6" >
        <div class="search-area-div">公司</div>
          <el-select size="mini" v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty" filterable clearable>
            <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
          </el-col>   
          <el-col :span="6">
          <div class="search-area-div">省份</div>
          <el-select size="mini" v-model="page.province" placeholder="请选择" class="ipt-sty w70f" >
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col  :span="6" class="search-btn-box"> 
            <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </el-col>
        </el-row>
    </div>   
    <div class=" back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p16"> 
          <el-button size="mini" type="info"  @click="report" v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button> 
      </div> 
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="customerCode" label="终端编码" header-align="center" width="150" align="center"></el-table-column> -->
        <el-table-column prop="customerName" label="终端名称" header-align="center" min-width="240" align="left" show-overflow-tooltip></el-table-column> 
        <el-table-column prop="terminalProperty" label="终端属性" header-align="center" width="120" align="left"></el-table-column> 
        <el-table-column prop="directStoresNum" label="直营门店数量" header-align="center" width="110" align="right">
          <template slot-scope="scope">
            <span>{{scope.row.directStoresNum || 0}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="affiliatedShopNum" label="加盟门店数量" header-align="center" align="right"  width="110">
          <template slot-scope="scope">
            <span>{{scope.row.directStoresNum || 0}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="省/市/区(县)" header-align="center" align="left"  width="190" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-show="scope.row.province && scope.row.city">
              {{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district(1)}}
            </span>
            <span v-show="scope.row.province && !scope.row.city && !scope.row.district">
              {{ scope.row.province | province}}{{ scope.row.city | city(1)}}{{ scope.row.district | district(1)}}
            </span>
            <span v-show="!scope.row.province && !scope.row.city && !scope.row.district">-</span>
          </template>
        </el-table-column> 
        <el-table-column prop="address" label="详细地址" header-align="center"  align="left"  min-width="240" show-overflow-tooltip></el-table-column> 
        <el-table-column prop="contacts" label="终端联系人" header-align="center"  align="left"  width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.contacts || '-' }}</template>
        </el-table-column> 
        <el-table-column prop="contactTel" label="终端联系电话" header-align="center"  align="left"  width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.contactTel || '-'}}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="staffName" label="所属人员姓名" header-align="center"  align="left"  width="110">
           <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column> 
        <el-table-column prop="mobileNo" label="所属人员手机号" header-align="center"  align="left"  width="120">
           <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column> 
      <!--   <el-table-column label="操作" header-align="center" align="center" fixed='right'>
          <template slot-scope="scope">
            <a class="txt-color" @click="toLink(scope.row.guid)">详情</a> 
          </template>
        </el-table-column> -->
      </el-table> 
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   
  </div>
</template>

<script>  
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      options: areaJson,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        staffName: '',  
        startTime: '', 
        endTime: '', 
        customerName: '',  
        tenantGuid:'',
        province:'',
      },  
        tenantList:[],
        tableData:[],
        sendTime:'',
        right:'right',
        fullscreenLoading: false,
        tableLoading:false
    };
  },
  created() {
    // 列表 
    this.getTenantDz(); 
  }, 
  methods: { 
    // getTenantDz() { 
    //   let self = this; 
    //   self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{'enterpriseCate':'010201','pageIndex': 1,'pageSize': -1}).then(res => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
     getTenantDz(){
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          if(self.tenantList != null && self.tenantList.length > 0){
              self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          }
          self.getData(false);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },  
    empty() {
      let self = this; 
      self.page.pageIndex = 1;
      self.page.pageSize = 10;
      self.page.customerName = ''; 
      self.getData(true); 
    }, 
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;  
      }    
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/customer/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    report(){
        let self = this;
          self.fullscreenLoading = true;
          self.page.pageSize = -1;
          // self.page.performanceGuid = self.$router.history.current.query.guid;
          self.api.postJson(`/${serverConfig.msCustomerService}/customer/data/export-customer-report`, self.page).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              self.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
    }, 
    reportJx(colNames,datas,sheetName,fileNam){
        let self = this; 
          self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
          .then(res => {  
             let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              let fileName = fileNam;
              let objectUrl = URL.createObjectURL(blob);
              const link = document.createElement('a')
              link.download = fileName;
              link.href = objectUrl;
              link.click();
              self.fullscreenLoading = false;
          });
          self.empty();
    },  
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>